
import interstellarPoster from './images/Intersteller.jpg';
import inceptionPoster from './images/inception.jpg';
import Openhime from './images/Openheimer.jpg';
import Avatar2 from './images/Avatar2.jpg';
import kalki from "./images/kalki.jpg"
const Movielist = [
    {
        id: 1,
        name: "Kalki 2898 AD",
        lang1: "Hindi",
        rating: 5,
        duration: 165,
        desc: "When the world is taken over by darkness. A force will rise. A modern avatar of the Hindu god Vishnu, is said to have descended on Earth to protect the world from evil forces.",
        starring: "Prabhas, Deepika Padukone, Amitabh Bachchan",
        genres: "Sci-Fi",
        tag1: "Action",
        tag2: "Sci-Fi",
        tag3: "Mythology",
        poster: kalki,
        trailer: "https://youtu.be/kQDd1AhGIHk",
        date: "2024",
        cast1: "Prabhas",
        cast1Img: "https://img.indiaforums.com/person/640x480/1/2525-prabhas.jpg?c=4bM0D6",
        cast2: "Deepika Padukone",
        cast2Img: "https://in.bmscdn.com/iedb/artist/images/website/poster/large/deepika-padukone-2822-12-09-2017-06-31-43.jpg",
        cast3: "Amitabh Bachchan",
        cast3Img: "https://in.bmscdn.com/iedb/artist/images/website/poster/large/amitabh-bachchan-138-12-09-2017-02-34-37.jpg"
    },
    {
        id: 2,
        name: "Avatar: The Way of Water",
        lang1: "English",
        rating: 4.5,
        duration: 192,
        desc: "Jake Sully and Ney'tiri have formed a family and are doing everything to stay together. However, they must leave their home and explore the regions of Pandora. When an ancient threat resurfaces, Jake must fight a difficult war against the humans.",
        starring: "Sam Worthington, Zoe Saldana, Sigourney Weaver",
        genres: "Sci-Fi",
        tag1: "Adventure",
        tag2: "Fantasy",
        tag3: "Action",
        poster: Avatar2,
        trailer: "https://youtu.be/d9MyW72ELq0",
        date: "2022",
        cast1: "Sam Worthington",
        cast1Img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSXpRnUvrIRNYbTHYjro8l1YGRovYepBflcHw&s",
        cast2: "Zoe Saldana",
        cast2Img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR9phaPDWP5ZFRlPKuXJsMSrmauc1fQ1P298Q&s",
        cast3: "Sigourney Weaver",
        cast3Img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1o7heiF7AHelnkDafdFdHOEqjT50eRyoaFQ&s"
    },
    {
        id: 3,
        name: "Oppenheimer",
        lang1: "English",
        rating: 4.7,
        duration: 180,
        desc: "The story of J. Robert Oppenheimer and his role in the development of the atomic bomb during World War II.",
        starring: "Cillian Murphy, Emily Blunt, Robert Downey Jr.",
        genres: "Biography",
        tag1: "History",
        tag2: "Drama",
        tag3: "Thriller",
        poster: Openhime,
        trailer: "https://youtu.be/bK6ldnjE3Y0",
        date: "2023",
        cast1: "Cillian Murphy",
        cast1Img: "https://i.abcnewsfe.com/a/a1dde558-3f86-4016-b751-2d7013195fa2/cillian-murphy-gty-jef-231205_1701807371366_hpMain_16x9.jpg?w=992",
        cast2: "Emily Blunt",
        cast2Img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlrBR4BlgX17UE4bP2IuFQaxblTVgCEx2DEA&s",
        cast3: "Robert Downey Jr.",
        cast3Img: "https://hips.hearstapps.com/hmg-prod/images/robert-downey-jr-attends-the-premiere-of-columbia-pictures-news-photo-1579211396.jpg"
    },
    {
        id: 4,
        name: "Interstellar",
        lang1: "English",
        rating: 4.6,
        duration: 169,
        desc: "A team of explorers travel through a wormhole in space in an attempt to ensure humanity's survival.",
        starring: "Matthew McConaughey, Anne Hathaway, Jessica Chastain",
        genres: "Sci-Fi",
        tag1: "Adventure",
        tag2: "Drama",
        tag3: "Sci-Fi",
        poster: interstellarPoster,
        trailer: "https://youtu.be/zSWdZVtXT7E",
        date: "2014",
        cast1: "Matthew McConaughey",
        cast1Img: "https://m.media-amazon.com/images/M/MV5BMTg0MDc3ODUwOV5BMl5BanBnXkFtZTcwMTk2NjY4Nw@@._V1_FMjpg_UX1000_.jpg",
        cast2: "Anne Hathaway",
        cast2Img: "https://cdn.britannica.com/14/147814-050-664180CF/Anne-Hathaway.jpg",
        cast3: "Jessica Chastain",
        cast3Img: "https://m.media-amazon.com/images/M/MV5BMTU1MDM5NjczOF5BMl5BanBnXkFtZTcwOTY2MDE4OA@@._V1_.jpg"
        
    },
    {
        id: 5,
        name: "Inception",
        lang1: "English",
        rating: 4.8,
        duration: 148,
        desc: "A skilled thief, the absolute best in the dangerous art of extraction, steals valuable secrets from deep within the subconscious during the dream state, when the mind is at its most vulnerable.",
        starring: "Leonardo DiCaprio, Joseph Gordon-Levitt, Ellen Page",
        genres: "Sci-Fi",
        tag1: "Thriller",
        tag2: "Action",
        tag3: "Adventure",
        poster: inceptionPoster,
        trailer: "https://youtu.be/8hP9D6kZseM",
        date: "2010",
        cast1: "Leonardo DiCaprio",
        cast1Img: "https://i.pinimg.com/474x/4e/34/84/4e348498603a146d52cb97e1bc080bba.jpg",
        cast2: "Joseph Gordon-Levitt",
        cast2Img: "https://m.media-amazon.com/images/M/MV5BMTczNDUzMTg0M15BMl5BanBnXkFtZTcwNDg2NDQzNA@@._V1_.jpg",
        cast3: "Elliot Page",
        cast3Img: "https://variety.com/wp-content/uploads/2023/06/GettyImages-1439352620.jpg"
    },
];

export default Movielist